import { connect } from 'react-redux'
import { compose } from 'recompose'

import history from 'browserHistory'
import { dataFetched, makesMutations } from 'data/graphql'
import { createTemplate as createTemplateQuery } from 'remote/notes'
import RoutesHelper from 'helpers/RoutesHelper'

const providesCreateTemplateMutation = compose(
  connect(
    null,
    { dataFetched }
  ),
  makesMutations({
    query: createTemplateQuery,
    mutationPropName: 'createTemplate',
    getOnResultFromProps: ({ dataFetched }) => ({ result }) => {
      const template = result.data.createTemplate
      const url = RoutesHelper.noteTemplateShow({ noteId: template.id })

      dataFetched(template)
      history.push(url)

      return template
    },
  })
)

export default providesCreateTemplateMutation
